<template>
  <div id="app">
    <header-globulo />

    <!-- TODO faire un composant avec le header -->
    <div class="dashboard">
      <div id="head-page" class="globulo parallaxe" :style="{'background-color': bgcolor}">
        <div ref="scene" id="scene">
          <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
          <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
          <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
          <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
          <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
          <div id="front-1" data-depth="0.2"></div>
        </div>
      </div>
      
      <message-dispenser />
      <transition name="fade">
        <slot></slot>
      </transition>
    </div>

    <footer-globulo />
    <chat-messenger />
    <organites-scene />
  </div>
</template>

<script>
  import HeaderGlobulo from '@/components/HeaderLogin'
  import FooterGlobulo from '@/components/FooterGlobulo'
  import OrganitesScene from '@/components/OrganitesScene'
  import ChatMessenger from '@/components/ChatMessenger'
  import MessageDispenser from '@/components/CenteredMessageDispenser'
  import chroma from 'chroma-js'

  export default {
    components: { HeaderGlobulo, FooterGlobulo, OrganitesScene, MessageDispenser, ChatMessenger },
    data () {
      let scale = chroma.scale(['25243f', '7497cb', '65d4ff', 'd78d81', '25243f'])
      return {
        bgcolor: scale(new Date().getHours() / 24).toString(),
      }
    },
    computed: {
      authenticated () {
        return this.$store.state.auth.authenticated
      },
      threads () {
        return this.$store.state.threads
      }
    },
    mounted () {
      var scene = this.$refs.scene;
      var parallaxInstance = new Parallax(scene, {
        scalarY: 3
      });
    }
  }
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .6s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
   animation-name: leave;
   animation-duration: 0.8s;
}

@keyframes leave {
  from {opacity: 1;}
  to {opacity: 0;}
}
</style>
